import { combineEpics } from "redux-observable";
import { epicContractDismiss } from "./epics/epicContractDismiss";
import { epicContractFinishCooldown } from "./epics/epicContractFinishCooldown";
import { epicContractFulfill } from "./epics/epicContractFulfill";
import { epicContractInfoPlayerInfoReceived } from "./epics/epicContractInfoPlayerInfoReceived";
import { epicContractInfoPlayerLevelUp } from "./epics/epicContractInfoPlayerLevelUp";
import { epicContractInfoReceived } from "./epics/epicContractInfoReceived";
import { epicContractInfoRequest } from "./epics/epicContractInfoRequest";
import { epicContractInfoRequestImprovementUnlock } from "./epics/epicContractInfoRequestImprovementUnlock";
import { epicContractInfoRequestOnReconnect } from "./epics/epicContractInfoRequestOnReconnect";
import { epicContractStartCooldown } from "./epics/epicContractStartCooldown";
import { epicMarketContractRequestFulfill } from "./epics/epicMarketContractRequestFulfill";
import { epicMarketContractRequestSkip } from "./epics/epicMarketContractRequestSkip";
import { epicMarketContractSkip } from "./epics/epicMarketContractSkip";
export var epicContractInfo = combineEpics(epicContractInfoPlayerLevelUp, epicContractInfoPlayerInfoReceived, epicContractInfoRequest, epicContractInfoRequestImprovementUnlock, epicContractInfoRequestOnReconnect, epicContractFulfill, epicContractDismiss, epicMarketContractRequestSkip, epicMarketContractSkip, epicContractStartCooldown, epicContractFinishCooldown, epicMarketContractRequestFulfill, epicContractInfoReceived);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epicContractInfo.ts
// module id = 1987
// module chunks = 3